<template>
  <div class="component-upload-image">
    <el-upload
     multiple
     :auto-upload="false"
     :limit="limit"
     :action="uploadImgUrl"
     :on-preview="handlePictureCardPreview"
     :on-remove="handleDelete"
     :on-change="onFileChange"
     :on-exceed="handleExceed"
     :file-list="fileList"
     list-type="picture-card"
     :class="{hide: this.fileList.length >= this.limit}">
    	<div class="el-upload--picture-card"
       @click.capture="handleSelectClick">
    	  <i class="el-icon-plus"></i>
    	</div>
    	<template v-slot:file="{ file }">
    	  <!-- <img class="el-upload-list__item-image" :src="file.url"> -->
        <!-- 缩略图：只显示，不预览 -->
            <el-image
              :src="file.url"
              fit="contain"
              :preview-src-list="[]"
              @click.stop
            />

    	  <span class="el-upload-list__item-actions">
    	    <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
    	      <i class="operate el-icon-view"></i>
    	    </span>
    	    <span class="el-upload-list__item-delete" @click="handleDelete(file)">
    	      <i class="operate el-icon-delete"></i>
    	    </span>
    	  </span>
    	</template>
    </el-upload>

    <!-- 隐藏的 el-image，专职预览 -->
    <el-image
      style="display:none"
      ref="previewer"
      :preview-src-list="previewList"
      :initial-index="previewIndex"
    />
  </div>
</template>

<script>
import axios from 'axios'
import { getToken } from "@/utils/auth"
import {checkMd5} from '@/api/files/file.js'
import SparkMD5 from 'spark-md5';
import Sortable from 'sortablejs'
import { isExternal } from "@/utils/validate"

export default {
  props:{
    value: [String, Object, Array],
    // 图片数量限制
    limit: {
      type: Number,
      default: 120,
    },
    // 上传接口地址
    action: {
      type: String,
      default: "/file/upload"
    },
  },
  data() {
    return{
      baseUrl: process.env.VUE_APP_BASE_API,
      uploadImgUrl: process.env.VUE_APP_BASE_API + this.action, // 上传的图片服务器地址
      md5headers: {
        Authorization: "Bearer " + getToken(),
        'Content-Type': 'multipart/form-data',
      },
      fileList: [],
      previewList:[],
      previewIndex:0,
      unRepeatMd5Set:new Set(), //防止客户端误传相同文件（比如md5相同的两个文件3.png和4.png），他们其实是同一个文件，
                                //异步同时传将导致两次流量消耗，虽然不影响逻辑结果
    }
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          // 首先将值转为数组
          const list = Array.isArray(val) ? val : this.value.split(',')
          // 然后将数组转为对象数组
          this.fileList = list.map(item => {
            if (typeof item === "string") {
              if (item.indexOf(this.baseUrl) === -1 && !isExternal(item)) {
                  item = { name: this.baseUrl + item, url: this.baseUrl + item }
              } else {
                  item = { name: item, url: item }
              }
            }
            return item
          })
        } else {
          this.fileList = []
          return []
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods:{
    handleSelectClick() {
        console.log('新一轮文件选择，重置 MD5 Set')
        // this.unRepeatMd5Set.clear()//不要清理集合，可以防止重复上传
      },
    // 预览
    handlePictureCardPreview(file) {
        const index = this.fileList.findIndex(f => f.url === file.url)

          this.previewList = this.fileList.map(f => f.url)
          this.previewIndex = index

          this.$nextTick(() => {
            this.$refs.previewer.showViewer = true
          })
    },
    // 文件个数超出
    handleExceed() {
      this.$modal.msgError(`上传文件数量不能超过 ${this.limit} 个!`);
    },
    syncValue() {
      this.$emit("input", this.listToString(this.fileList))
    },
    // 删除图片
    handleDelete(file) {
      const findex = this.fileList.map(f => f.name).indexOf(file.name)
      if (findex > -1) {
        this.fileList.splice(findex, 1)
        this.syncValue()
      }
    },
    onFileChange(fileWrap, fileList) {
      console.log("onFileChange：",fileWrap);
      // 只在文件未处理过时计算 MD5
      // 已处理过或已上传成功的文件，直接返回
        if (fileWrap.md5 || fileWrap.status === 'success') return;

        // 立即赋一个临时标记，避免重复触发
        fileWrap.md5 = 'md5-init-value';
    	var _this = this;
    	// console.log("onFileChange");
    	var blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice,
    		// file = this.files[0],
    		file = fileWrap.raw,
    		chunkSize = 2097152, // Read in chunks of 2MB
    		chunks = Math.ceil(file.size / chunkSize),
    		currentChunk = 0,
    		spark = new SparkMD5.ArrayBuffer(),
    		fileReader = new FileReader();

    	fileReader.onload = function(e) {
        console.log(currentChunk);
        // Element UI on-change may fire multiple times, guard against duplicate MD5 computing
    		// if (fileWrap.md5) return; //防止重复计算MD5
    		// console.log('read chunk nr', currentChunk + 1, 'of', chunks);
    		spark.append(e.target.result); // Append array buffer
    		currentChunk++;

    		if (currentChunk < chunks) {
    			loadNext();
    		} else {
    			// console.log('finished loading');
    			fileWrap.md5 = spark.end();

    			// console.info('computed hash', fileWrap.md5); // Compute hash
          if (!_this.unRepeatMd5Set.has(fileWrap.md5)) {
              _this.unRepeatMd5Set.add(fileWrap.md5);
              _this.checkMd5FromServer(fileWrap.md5,fileWrap); //检查MD5
          } else {
              console.log('重复文件，跳过上传', fileWrap.md5);
          }


    		}
    	};

    	fileReader.onerror = function() {
    		console.warn('oops, something went wrong.');
    	};

    	function loadNext() {
    		var start = currentChunk * chunkSize,
    			end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize;

    		fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
    	}

    	loadNext();
    },
    async checkMd5FromServer(md5, file) {
      console.log("得到文件md5：", md5)

      const resp = await checkMd5(md5)
      console.log(resp)

      if (resp.fileExists) {
        // 文件已存在（秒传）
        file.url = this.baseUrl + resp.data.url
        this.fileList.push(file)
        this.syncValue()
      } else {
        // 新文件：才计算宽高（你的策略是完全正确的 👍）
        const { width, height } = await this.readImageSizeFromRaw(file.raw)

        const form = new FormData()
        form.append('file', file.raw)
        form.append('md5', md5)
        form.append('width', width)
        form.append('height', height)

        console.log("文件上传：",width, height);

        const response = await axios.post(this.uploadImgUrl, form, {
          headers: this.md5headers
        })

        console.log("上传成功：", response)

        const { code, fileName } = response.data
        if (code === 200) {
          file.url = this.baseUrl + fileName
          this.fileList.push(file);
          //允许重复-给予一定灵活度
          // this.handleUploadSuccess(file,file.url);
          this.syncValue()
        }
      }
    },
    readImageSizeFromRaw(file) {
      return new Promise((resolve, reject) => {
        // 非图片直接跳过
        if (!file.type.startsWith("image/")) {
          return resolve({ width: 0, height: 0 })
        }

        const img = new Image()
        const url = URL.createObjectURL(file)

        img.onload = () => {
          const width = img.naturalWidth
          const height = img.naturalHeight
          URL.revokeObjectURL(url) // 重要：释放内存
          resolve({ width, height })
        }

        img.onerror = () => {
          URL.revokeObjectURL(url)
          resolve({ width: 0, height: 0 }) // 不 throw，保证流程不断
        }

        img.src = url
      })
    },
    handleUploadSuccess(file, url) {
      // url 去重
      const exists = this.fileList.some(f => f !== file && f.url === url)
      if (exists) {
        console.log('UI 去重，丢弃重复文件', url)
        this.removeFile(file)
        return
      }

      file.url = url
      file.status = 'success'
      this.syncValue()
    },
    removeFile(file) {
      const idx = this.fileList.indexOf(file)
      if (idx > -1) {
        this.fileList.splice(idx, 1)
      }
    },
    // 对象转成指定字符串分隔
    listToString(list, separator) {
      let strs = ""
      separator = separator || ","
      for (let i in list) {
        if (list[i].url) {
          strs += list[i].url.replace(this.baseUrl, "") + separator
        }
      }
      return strs != '' ? strs.substr(0, strs.length - 1) : ''
    },
  },
}
</script>
<style scoped lang="scss">
// .el-upload--picture-card 控制加号部分
::v-deep.hide .el-upload--picture-card {
  display: none;
}

::v-deep .el-upload-list--picture-card.is-disabled + .el-upload--picture-card {
  display: none !important;
}

// 去掉动画效果
::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
  transition: all 0s;
}

::v-deep .el-list-enter, .el-list-leave-active {
  opacity: 0;
  transform: translateY(0);
}

/* Scoped 样式 + ::v-deep */
::v-deep .el-upload-list__item .el-image {
  width: 100%;
  height: 100%;
}

</style>

